export default __webpack_public_path__ + "static/media/img-1.47c93015.jpg";